"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CurrentAccommodationPreferencesDto {
}
exports.CurrentAccommodationPreferencesDto = CurrentAccommodationPreferencesDto;
